module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_7016.ef7b63fe.png";